import {
  FieldConfig,
  FieldValidations,
} from "layouts/NewUniversalField/NewUniversalField";
import { BillerCustomerParam } from "./billerTypes";

function toSafeId(paramName: string): string {
  return paramName
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
}

function detectAllowedChars(dataType: string, regex?: string) {
  const type = dataType.toUpperCase();
  if (type === "NUMERIC") return "numeric" as const;
  if (type === "ALPHA") return "alpha" as const;
  if (type === "ALPHANUMERIC") return "alphanumeric" as const;

  // crude detection
  if (regex?.includes("[0-9]") && !regex?.match(/[A-Za-z]/)) {
    return "numeric" as const;
  }
  if (regex?.includes("[A-Za-z]") && !regex?.match(/[0-9]/)) {
    return "alpha" as const;
  }
  if (regex?.match(/[0-9]/) && regex?.match(/[A-Za-z]/)) {
    return "alphanumeric" as const;
  }

  return undefined;
}

export function mapCustomerParamsToFields(
  params: BillerCustomerParam[] | undefined,
): {
  fields: FieldConfig[];
  initialValues: Record<string, string>;
  fieldIdToParamName: Record<string, string>;
} {
  const fields: FieldConfig[] = [];
  const initialValues: Record<string, string> = {};
  const fieldIdToParamName: Record<string, string> = {};

  if (!params || params.length === 0) {
    return { fields, initialValues, fieldIdToParamName };
  }

  for (const p of params) {
    const id = toSafeId(p.paramName);
    const required =
      typeof p.optional === "string"
        ? p.optional.toLowerCase() === "false"
        : !p.optional;

    const validations: FieldValidations = {};
    if (p.minLength) validations.minLength = Number(p.minLength);
    if (p.maxLength) validations.maxLength = Number(p.maxLength);

    const allowedChars = detectAllowedChars(p.dataType, p.regex);
    if (allowedChars) validations.allowedChars = allowedChars;

    const field: FieldConfig = {
      id,
      label: p.paramName,
      as: "input",
      type: "text",
      placeholder: p.paramName, // tumhari requirement
      required,
      validations,
      meta: { billerParamName: p.paramName },
    };

    fields.push(field);
    initialValues[id] = "";
    fieldIdToParamName[id] = p.paramName;
  }

  return { fields, initialValues, fieldIdToParamName };
}
